import { Group, Stack, Text, Tooltip } from '@mantine/core'

export interface ClaimHeaderProps {
  title: string
  claimNumber: string
  insuredName: string
  insurerName: string
  dateOfLoss: string
}

export function ClaimHeader({ title, claimNumber, insuredName, insurerName, dateOfLoss }: Readonly<ClaimHeaderProps>) {
  return (
    <Stack gap={4}>
      <Group justify="space-between" wrap="nowrap">
        <Stack gap={0} style={{ minWidth: 0 }}>
          <Tooltip label={title} withArrow openDelay={400} multiline maw={300}>
            <Text fw={600} fz="sm" truncate>
              {title}
            </Text>
          </Tooltip>
        </Stack>
        <Text fz="xs" c="brand.7" td="underline" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
          {claimNumber}
        </Text>
      </Group>
      <Group justify="space-between" wrap="nowrap">
        <Text fz="xs" truncate>
          Insurer: {insurerName}
        </Text>
        <Text fz="xs" style={{ whiteSpace: 'nowrap' }}>
          DOL: {dateOfLoss}
        </Text>
      </Group>
      <Text fz="xs">Insured: {insuredName}</Text>
    </Stack>
  )
}
